(function () {
  const HEURISTICS = [
    { test: /teardrop|drop/, x: 50, y: 58, scale: 3.4 },
    { test: /bar/, x: 47.5, y: 48.4, scale: 2.4 },
    { test: /puffy|heart/, x: 50, y: 56, scale: 3.6 },
    { test: /cross/, x: 50, y: 54, scale: 3.2 },
    { test: /moon|wing|paw|coin|round/, x: 50, y: 55, scale: 3.4 },
  ];

  function placementFrom(config) {
    const hasX = config.x !== null && config.x !== "" && Number.isFinite(Number(config.x));
    const hasY = config.y !== null && config.y !== "" && Number.isFinite(Number(config.y));
    const hasScale = config.scale !== null && config.scale !== "" && Number.isFinite(Number(config.scale));
    const match = HEURISTICS.find((item) => item.test.test(config.handle || ""));
    const base = match || { x: 50, y: 56, scale: 3.4 };
    if (config.hasCustomPic && hasX && hasY) {
      return {
        x: Number(config.x),
        y: Number(config.y),
        scale: hasScale ? Number(config.scale) : base.scale,
      };
    }
    return { ...base };
  }

  class PurnebuCustomizer extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const raw = this.querySelector("[data-purnebu-config]");
      if (!raw) return;
      this.config = JSON.parse(raw.textContent);
      const none = { id: "none", label: "None", overlay: "" };
      this.state = {
        font: this.config.fonts[0],
        text: "",
        zodiac: (this.config.zodiac && this.config.zodiac[0]) || none,
        shape: (this.config.shapes && this.config.shapes[0]) || none,
      };
      this.placement = placementFrom(this.config);
      document.querySelectorAll(".purnebu-gallery-engrave").forEach((node) => node.remove());
      this.cache();
      this.renderFonts();
      this.renderChooser(this.zodiacChooser, this.config.zodiac, "zodiac");
      this.renderChooser(this.shapeChooser, this.config.shapes, "shape");
      this.bind();
      if (this.baseImage) {
        this.baseImage.addEventListener("load", () => this.paint());
        this.baseImage.src = this.config.preview;
      }
      this.sync();
    }

    cache() {
      this.modal = this.querySelector("[data-modal]");
      this.stage = this.querySelector("[data-stage]");
      this.baseImage = this.querySelector("[data-base-image]");
      this.engrave = this.querySelector("[data-engrave]");
      this.fontToggle = this.querySelector("[data-font-toggle]");
      this.fontLabel = this.querySelector("[data-font-label]");
      this.fontList = this.querySelector("[data-font-list]");
      this.textInput = this.querySelector("[data-text-input]");
      this.charCount = this.querySelector("[data-char-count]");
      this.zodiacChooser = this.querySelector("[data-zodiac-chooser]");
      this.shapeChooser = this.querySelector("[data-shape-chooser]");
      this.summary = this.querySelector("[data-summary]");
      this.summaryText = this.querySelector("[data-summary-text]");
      this.propFont = this.querySelector("[data-prop-font]");
      this.propText = this.querySelector("[data-prop-text]");
      this.propZodiac = this.querySelector("[data-prop-zodiac]");
      this.propShape = this.querySelector("[data-prop-shape]");
      this.modalHome = this.modal.parentElement;
    }

    $all(selector) {
      return (this.modal || this).querySelectorAll(selector);
    }

    $(selector) {
      return (this.modal || this).querySelector(selector);
    }

    renderFonts() {
      this.fontList.innerHTML = "";
      this.config.fonts.forEach((font) => {
        const li = document.createElement("li");
        const button = document.createElement("button");
        button.type = "button";
        button.textContent = font.label;
        button.style.fontFamily = font.family;
        button.style.fontSize = font.id === "arial" ? "15px" : "22px";
        button.dataset.fontId = font.id;
        button.addEventListener("click", () => {
          this.state.font = font;
          this.closeMenus();
          this.sync();
        });
        li.appendChild(button);
        this.fontList.appendChild(li);
      });
    }

    pickMarkup(item, extra = "") {
      const icon = item.id === "none"
        ? `<span class="purnebu-customizer__none"></span>`
        : `<img src="${item.card}" alt="" width="40" height="40">`;
      return `${icon}<span>${item.label}</span>${extra}`;
    }

    selectedBadge() {
      return `<span class="purnebu-customizer__badge">Selected</span>`;
    }

    renderChooser(root, items, key) {
      if (!root || !items || !items.length) return;
      const selected = this.state[key];
      const featured = items.slice(0, 4);
      const overflow = items.slice(4);
      const selectedInOverflow = overflow.some((item) => item.id === selected.id);
      const shown = selectedInOverflow ? [selected, ...featured.slice(0, 3)] : featured;

      root.innerHTML = "";
      shown.forEach((item) => {
        root.appendChild(this.card(item, key, item.id === selected.id));
      });

      const more = this.$(`[data-more="${key}"]`);
      if (!more) return;
      const list = more.querySelector("[data-more-list]");
      const toggle = more.querySelector("[data-more-toggle]");
      const label = more.querySelector("[data-more-label]");
      list.innerHTML = "";
      if (overflow.length) {
        more.hidden = false;
        overflow.forEach((item) => list.appendChild(this.moreItem(item, key, item.id === selected.id)));
      } else {
        more.hidden = true;
      }
      if (label) label.textContent = selectedInOverflow ? "Change item" : "See more";
      more.classList.toggle("is-change", selectedInOverflow);
      toggle.setAttribute("aria-expanded", "false");
      list.hidden = true;
      list.removeAttribute("data-drop");
    }

    card(item, key, selected) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "purnebu-customizer__card";
      button.setAttribute("aria-pressed", selected ? "true" : "false");
      button.innerHTML = this.pickMarkup(item, selected ? this.selectedBadge() : "");
      button.addEventListener("click", () => {
        this.state[key] = item;
        this.closeMenus();
        this.sync();
      });
      return button;
    }

    moreItem(item, key, selected) {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "purnebu-customizer__more-item";
      button.setAttribute("aria-current", selected ? "true" : "false");
      button.innerHTML = this.pickMarkup(item, selected ? this.selectedBadge() : "");
      button.addEventListener("click", () => {
        this.state[key] = item;
        this.closeMenus();
        this.sync();
      });
      return button;
    }

    bind() {
      this.querySelector("[data-open]").addEventListener("click", () => this.open());
      this.querySelectorAll("[data-close]").forEach((node) => {
        node.addEventListener("click", () => this.close());
      });
      this.fontToggle.addEventListener("click", (event) => {
        event.stopPropagation();
        const open = this.fontToggle.getAttribute("aria-expanded") === "true";
        this.closeMenus();
        if (!open) this.openFont();
      });
      this.fontList.addEventListener("click", (event) => event.stopPropagation());
      this.$all("[data-more-toggle]").forEach((toggle) => {
        toggle.addEventListener("click", (event) => {
          event.stopPropagation();
          const wrap = toggle.closest("[data-more]");
          const list = wrap.querySelector("[data-more-list]");
          const open = toggle.getAttribute("aria-expanded") === "true";
          this.closeMenus();
          if (!open) {
            toggle.setAttribute("aria-expanded", "true");
            this.placeMore(wrap);
            list.hidden = false;
          }
        });
      });
      this.querySelectorAll("[data-more-list]").forEach((list) => {
        list.addEventListener("click", (event) => event.stopPropagation());
      });
      this.textInput.addEventListener("input", () => {
        this.state.text = this.textInput.value.slice(0, this.config.maxChars);
        this.sync({ skipChooser: true });
      });
      this._onDocClick = () => this.closeMenus();
      this._onKey = (event) => {
        if (event.key === "Escape") {
          this.closeMenus();
          if (!this.modal.hidden) this.close();
        }
      };
      document.addEventListener("click", this._onDocClick);
      document.addEventListener("keydown", this._onKey);
      window.addEventListener("resize", () => {
        if (!this.modal.hidden) this.paint();
      });
    }

    open() {
      document.body.appendChild(this.modal);
      this.modal.hidden = false;
      this.closeMenus();
      document.body.classList.add("purnebu-customizer-open");
      this.sync();
      requestAnimationFrame(() => this.paint());
    }

    close() {
      this.modal.hidden = true;
      this.closeMenus();
      document.body.classList.remove("purnebu-customizer-open");
      if (this.modalHome) this.modalHome.appendChild(this.modal);
    }

    openFont() {
      this.fontToggle.setAttribute("aria-expanded", "true");
      this.fontList.hidden = false;
    }

    placeMore(wrap) {
      const list = wrap.querySelector("[data-more-list]");
      const toggle = wrap.querySelector("[data-more-toggle]");
      const foot = this.$(".purnebu-customizer__dialog-foot");
      if (!list || !toggle) return;
      const space = foot
        ? foot.getBoundingClientRect().top - toggle.getBoundingClientRect().bottom
        : 999;
      list.dataset.drop = space < 220 ? "up" : "down";
    }

    closeMenus() {
      if (this.fontToggle) {
        this.fontToggle.setAttribute("aria-expanded", "false");
        this.fontList.hidden = true;
      }
      this.$all("[data-more-toggle]").forEach((toggle) => {
        toggle.setAttribute("aria-expanded", "false");
      });
      this.$all("[data-more-list]").forEach((list) => {
        list.hidden = true;
      });
    }

    paint() {
      const target = this.engrave;
      const img = this.baseImage;
      if (!target || !img) return;
      const { font, text, zodiac, shape } = this.state;
      const empty = !text && zodiac.id === "none" && shape.id === "none";
      target.dataset.empty = empty ? "true" : "false";
      const box = contentBox(img);
      target.style.left = `${box.ox + (this.placement.x / 100) * box.dw}px`;
      target.style.top = `${box.oy + (this.placement.y / 100) * box.dh}px`;
      target.style.fontSize = `${(this.placement.scale / 100) * box.dw}px`;
      target.style.fontFamily = font.family;
      const bits = [];
      if (zodiac && zodiac.overlay) {
        bits.push(`<img class="purnebu-customizer__mark-img" src="${zodiac.overlay}" alt="">`);
      }
      if (text) bits.push(`<span class="purnebu-customizer__word">${escapeHtml(text)}</span>`);
      if (shape && shape.overlay) {
        bits.push(`<img class="purnebu-customizer__mark-img" src="${shape.overlay}" alt="">`);
      }
      target.innerHTML = bits.join("");
    }

    sync(options = {}) {
      this.fontLabel.textContent = this.state.font.label;
      this.fontLabel.style.fontFamily = this.state.font.family;
      this.fontLabel.style.fontSize = this.state.font.id === "arial" ? "14px" : "22px";
      this.charCount.textContent = `${this.state.text.length}/${this.config.maxChars}`;
      this.$all("[data-font-list] button").forEach((button) => {
        button.setAttribute("aria-current", button.dataset.fontId === this.state.font.id ? "true" : "false");
      });
      if (!options.skipChooser) {
        this.renderChooser(this.zodiacChooser, this.config.zodiac, "zodiac");
        this.renderChooser(this.shapeChooser, this.config.shapes, "shape");
      }

      const customized = Boolean(this.state.text) || this.state.zodiac.id !== "none" || this.state.shape.id !== "none";
      writeProp(this.propFont, customized ? this.state.font.label : "");
      writeProp(this.propText, this.state.text);
      writeProp(this.propZodiac, this.state.zodiac.id !== "none" ? this.state.zodiac.label : "");
      writeProp(this.propShape, this.state.shape.id !== "none" ? this.state.shape.label : "");

      const parts = [];
      if (this.state.text) parts.push(this.state.text);
      if (this.state.zodiac.id !== "none") parts.push(this.state.zodiac.label);
      if (this.state.shape.id !== "none") parts.push(this.state.shape.label);
      if (parts.length) {
        this.summary.hidden = false;
        this.summaryText.textContent = `${this.state.font.label} · ${parts.join(" · ")}`;
      } else {
        this.summary.hidden = true;
        this.summaryText.textContent = "";
      }
      this.paint();
    }
  }

  function contentBox(img) {
    const nw = img.naturalWidth || 1;
    const nh = img.naturalHeight || 1;
    const w = img.clientWidth || 1;
    const h = img.clientHeight || 1;
    const nr = nw / nh;
    const r = w / h;
    if (nr > r) {
      const dw = w;
      const dh = w / nr;
      return { ox: 0, oy: (h - dh) / 2, dw, dh };
    }
    const dh = h;
    const dw = h * nr;
    return { ox: (w - dw) / 2, oy: 0, dw, dh };
  }

  function writeProp(input, value) {
    if (!input) return;
    input.value = value;
    input.disabled = !value;
  }

  function escapeHtml(value) {
    return value
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  if (!customElements.get("purnebu-customizer")) {
    customElements.define("purnebu-customizer", PurnebuCustomizer);
  }
})();
